export default __webpack_public_path__ + "static/media/asana-icon.48929aa5.svg";